/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { TypeOfAnaesthesia } from 'app/shared/model/enumerations/type-of-anaesthesia.model';
import { ASACategory } from 'app/shared/model/enumerations/asa-category.model';
import { createEntity, getEntity, reset, updateEntity } from './pre-op-review-pac.reducer';

export const PreOpReviewPACUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const preOpReviewPACEntity = useAppSelector(state => state.preOpReviewPAC.entity);
  const loading = useAppSelector(state => state.preOpReviewPAC.loading);
  const updating = useAppSelector(state => state.preOpReviewPAC.updating);
  const updateSuccess = useAppSelector(state => state.preOpReviewPAC.updateSuccess);
  const typeOfAnaesthesiaValues = Object.keys(TypeOfAnaesthesia);
  const aSACategoryValues = Object.keys(ASACategory);

  const handleClose = () => {
    navigate(`/pre-op-review-pac${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...preOpReviewPACEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      reviewedBy: doctors.find(it => it.id.toString() === values.reviewedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          recomendedTypeOfAnaesthesia: 'GA',
          asaCategory: 'ASA_I',
          ...preOpReviewPACEntity,
          surgery: preOpReviewPACEntity?.surgery?.id,
          reviewedBy: preOpReviewPACEntity?.reviewedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preOpReviewPAC.home.createOrEditLabel" data-cy="PreOpReviewPACCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.home.createOrEditLabel">Create or edit a PreOpReviewPAC</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-op-review-pac-id"
                  label={translate('tinyMedicRestApp.preOpReviewPAC.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.notes')}
                id="pre-op-review-pac-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.active')}
                id="pre-op-review-pac-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.cursor')}
                id="pre-op-review-pac-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.lastupdated')}
                id="pre-op-review-pac-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.microSec')}
                id="pre-op-review-pac-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.timestampentry')}
                id="pre-op-review-pac-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.fitForProcedure')}
                id="pre-op-review-pac-fitForProcedure"
                name="fitForProcedure"
                data-cy="fitForProcedure"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.recomendedTypeOfAnaesthesia')}
                id="pre-op-review-pac-recomendedTypeOfAnaesthesia"
                name="recomendedTypeOfAnaesthesia"
                data-cy="recomendedTypeOfAnaesthesia"
                type="select"
              >
                {typeOfAnaesthesiaValues.map(typeOfAnaesthesia => (
                  <option value={typeOfAnaesthesia} key={typeOfAnaesthesia}>
                    {translate(`tinyMedicRestApp.TypeOfAnaesthesia.${typeOfAnaesthesia}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpReviewPAC.asaCategory')}
                id="pre-op-review-pac-asaCategory"
                name="asaCategory"
                data-cy="asaCategory"
                type="select"
              >
                {aSACategoryValues.map(aSACategory => (
                  <option value={aSACategory} key={aSACategory}>
                    {translate(`tinyMedicRestApp.ASACategory.${aSACategory}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="pre-op-review-pac-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.preOpReviewPAC.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-review-pac-reviewedBy"
                name="reviewedBy"
                data-cy="reviewedBy"
                label={translate('tinyMedicRestApp.preOpReviewPAC.reviewedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-op-review-pac" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreOpReviewPACUpdate;
